import { Component, Vue, Prop as prop} from 'nuxt-property-decorator';
import Swiper from 'swiper';

@Component({
    components: {
        offer: require('~/components/catalog/offer/').default,
    },
})
export default class OfferHorisontalSliderComponent extends Vue {

    infiniteState: string = 'idle';

    @prop()
    public data!: OfferList;

    @prop({default: false, type: Boolean})
    public hideHeader: boolean;

    @prop({default: false, type: Boolean})
    public showBorder: boolean;

    @prop({default: true, type: Boolean})
    public hideEmpty: boolean;

    @prop({default: false, type: Boolean})
    public small: boolean;

    @prop()
    public infiniteLoader: (callbacks: {
        complete: () => void,
        loaded: () => void,
    }, list: OfferList) => Promise<void>;

    get swiperOptions() {
        const options: any = {
            watchOverflow: true,
            on: {
                slideChange: (event: Swiper) => {
                    if (!this.infiniteLoader || this.infiniteState !== 'idle') {
                        return;
                    }
    
                    if (event.activeIndex <= this.data.offers.length - 5) {
                        return;
                    }
    
                    this.infiniteState = 'loading';
    
                    this.infiniteLoader({
                        complete: () => {this.infiniteState = 'complete';},
                        loaded: () => {this.infiniteState = 'idle';},
                    }, this.data).catch(() => {
                        this.infiniteState = 'complete';
                    })
                },
            },
            navigation: {
                prevEl: `#offer-list-${this.data.id} .left.arrow`,
                nextEl: `#offer-list-${this.data.id} .right.arrow`,
            },
        };

        if (!this.small) {
            options.slidesPerView = 3;
            options.slidesPerGroup = 3;
            options.spaceBetween = 10;
            options.breakpoints = {
                1450: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    spaceBetween: 30,
                },
                1400: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    spaceBetween: 20,
                },
                1190: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 30,
                },
                100: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 20,
                },
            };
        } else {
            options.slidesPerView = 2;
            options.slidesPerGroup = 2;
            options.spaceBetween = 30;
            options.breakpoints = {
                1400: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 30,
                },
                1190: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 30,
                },
                100: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 20,
                },
            };
        }

        return options;
    }

    get filteredOffers() {

        if (!this.data.offers.length) {
            return [];
        }

        return this.data.offers.filter((el) => el.price?.price && el.pictures?.length);
    }
}
